import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

const initialState = {
  openedViaBtnMenu: false,
  menuItemRefresh:  false,
};

export const openMenuSlice = createSlice({
  name: 'openMenu',
  initialState,
  reducers: {
    changeMenuVisibilityViaBtn: (state) => {
      state.openedViaBtnMenu = !state.openedViaBtnMenu;
    },
    stateMenuItemRefresh:(state, action: PayloadAction<boolean>) => {
      state.menuItemRefresh = action.payload;
    },
  },
});

export const { changeMenuVisibilityViaBtn, stateMenuItemRefresh } = openMenuSlice.actions;

export const openedViaBtnMenu = (state: RootState) => state.openedViaBtnMenu.openedViaBtnMenu;

export const selectMenuItemRefresh = (state: RootState) => state.openedViaBtnMenu.menuItemRefresh;
